import querystring from "querystring";
import pathToRegexp from "path-to-regexp";
import { prepareNav } from './routeHelpers';
import { getFilter } from './search';

const pathNav = '/:type?/:subtype?/:id?'
const pathMap = '/map=:zoom/:x/:y/:rot'
const pathNavCompile = pathToRegexp.compile(pathNav)
const pathMapCompile = pathToRegexp.compile(pathMap)
const pathNavRegexp = pathToRegexp(pathNav)
const pathMapRegexp = pathToRegexp(pathMap)

const LIST_TYPES_PATH = [
  { listType: 'tereny', pathType: 'investment-areas' },
  { listType: 'hale', pathType: 'halls' },
  { listType: 'biura', pathType: 'offices' },
  { listType: 'inwestorzy', pathType: 'invested-areas' },
]

function pathTypeFromListType(listType) {
  return LIST_TYPES_PATH.find(x => x.listType === listType).pathType
}

function listTypeFromPathType(pathType) {
  let found = LIST_TYPES_PATH.find(x => x.pathType === pathType)
  return found && found.listType
}

export function toHash({ nav, view }) {
  let type = undefined
  let subtype = undefined
  let id = undefined
  if (nav.listType !== undefined) {
    type = pathTypeFromListType(nav.listType)
    if (nav.type == 'list') {
      if (nav.gminaId) {
        subtype = 'community'
        id = nav.gminaId
      } else if (nav.powiatId) {
        subtype = 'district'
        id = nav.powiatId
      } else {
        subtype = 'list'
      }
    } else if (nav.type == 'details') {
      subtype = 'details'
      id = nav.id
    }
  }

  let navPath = pathNavCompile({
    type,
    subtype,
    id,
  })
  let mapPath = ""

  if (view) {
    let zoom = view.getZoom();
    let center = view.getCenter();
    let rotation = view.getRotation();
    mapPath = pathMapCompile({
      zoom: zoom,
      x: Math.round(center[0] * 100) / 100,
      y: Math.round(center[1] * 100) / 100,
      rot: rotation,
    })
  }
  return '#' + (navPath + mapPath).replace(/^[/]*/, "")
}

function navFromNavPath(inPathNav) {
  let matchNav = pathNavRegexp.exec(inPathNav)
  if (matchNav) {
    let pathType = matchNav[1]
    let pathSubtype = matchNav[2]
    let pathId = matchNav[3]

    let listType = listTypeFromPathType(pathType)
    if (listType) {
      switch (pathSubtype) {
        case 'details':
          return {
            type: 'details',
            listType,
            id: parseInt(pathId),
            powiatId: undefined,
            gminaId: undefined,
          }
        case 'list':
          return {
            type: 'list',
            listType,
            powiatId: undefined,
            gminaId: undefined,
          }
        case 'district':
          return {
            type: 'list',
            listType,
            powiatId: parseInt(pathId),
            gminaId: undefined,
          }
        case 'community':
          return {
            type: 'list',
            listType,
            powiatId: undefined,
            gminaId: parseInt(pathId),
          }
      }
    }
  }
}

function updateFromNavPath(inPathNav, store) {
  let nav = navFromNavPath(inPathNav)
  if (nav) {
    // watch from $store.commit does not seem to be instant
    nav.isFromPath = true
    store.commit("setNav", prepareNav(nav))
  }
}

function updateFromMapPath(inPathMap, view) {
  let matchMap = pathMapRegexp.exec(inPathMap)
  if (matchMap) {
    view.setZoom(
      parseFloat(matchMap[1])
    );
    view.setCenter([
      parseFloat(matchMap[2]),
      parseFloat(matchMap[3]),
    ]);
    view.setRotation(
      parseFloat(matchMap[4])
    );
  }
}


let wielkosc_przedsiebiorstwa_convert = {
  "big": "duze",
  "medium": "srednie",
  "small": "male",
  "micro": "mikro",
};


function updateFromQueryPath(inPathQuery) {
  // inPathQuery = "key2=value2&key2=value2"
  // filter-expenditures
  // filter-expenditures-currency - PLN/EUR/USD
  // filter-size - micro/small/medium/big
  let query = querystring.parse(inPathQuery);
  let naklady = query['filter-expenditures'];
  let waluta = query['filter-expenditures-currency'];
  let wielkosc_przedsiebiorstwa = wielkosc_przedsiebiorstwa_convert[query['filter-size']];

  if (naklady && waluta && wielkosc_przedsiebiorstwa) {

    getFilter({
      filter: {
        listType: "tereny",
      },
      waluta,
      naklady,
      wielkosc_przedsiebiorstwa,
    }).then(filter => {
      let vm = window.vm;
      vm.$store.commit("search/setFilter", filter);
    });
  }
}

function explodeHash(hash) {
  let nav, map, query;

  let inPath = '/' + hash.substring(1);
  let inPathsQuery = inPath.split('?');
  let inPathsMap = inPathsQuery[0].split('/map=');
  nav = inPathsMap[0];
  if (inPathsMap.length === 2) {
    map = '/map=' + inPathsMap[1];
  } else {
    map = undefined;
  }
  if (inPathsQuery.length === 2) {
    query = inPathsQuery[1];
  } else {
    query = undefined;
  }
  return {
    nav, map, query
  }
}

export function navFromHash(hash) {
  let {nav} = explodeHash(hash);
  return navFromNavPath(nav);
}

export function updateFromHash({ hash, view, store }) {
  try {
    let {nav, map, query} = explodeHash(hash);
    updateFromNavPath(nav, store);
    if (map) {
      updateFromMapPath('/map=' + map, view);
    }
    if (query) {
      updateFromQueryPath(query, view);
    }
  } catch (e) {
    console.error(e)
  }
}
